<template>
  <span v-if="badge" :class="status === 'danger' ? 'text-red' : ''">
    <b-badge :title="ttitle" :variant="status">
      <i class="fe fe-clock"></i>
    </b-badge>
    {{ texto }}
  </span>
  <span v-else :class="status === 'danger' ? 'text-red' : ''">
    <span v-if="concatStringText">
      <ReduceText :objStringg="concatStringText" :show_all="show_all" />&nbsp;
    </span>
    <span v-else>
      {{ texto }}
    </span>
  </span>
</template>

<script>
import ReduceText from "./ReduceText.vue";
export default {
  name: "Sla",
  props: [
    "estimate_delivery_date",
    "badge",
    "texto",
    "texto1",
    "texto2",
    "texto3",
    "texto4",
    "show_all",
    "before_status",
  ],
  components: { ReduceText },
  data() {
    return {
      ttitle: "",
      status: null,
      concatStringText: null,
    };
  },
  beforeMount() {
    if (
      this.before_status !== "canceled" &&
      this.before_status !== "delivered" &&
      this.before_status !== "partial_delivered"
    ) {
      this.ttitle = this.getTitle();
      this.status = this.getStatus();
    }
    if (this.texto1 !== undefined) this.concatString();
  },
  methods: {
    concatString() {
      this.concatStringText = "";
      if (this.texto1 !== undefined && this.texto1 !== null)
        this.concatStringText += this.texto1 + " ";
      if (this.texto2 !== undefined && this.texto2 !== null)
        this.concatStringText += this.texto2 + " ";
      if (this.texto3 !== undefined && this.texto3 !== null)
        this.concatStringText += this.texto3 + " ";
      if (this.texto4 !== undefined && this.texto4 !== null)
        this.concatStringText += this.texto4 + " ";
    },
    calculateHours(onTime = true) {
      var inicio = this.getDataTimeOn();
      var fim = this.parseDate(this.estimate_delivery_date);
      var resultado = "";
      if (!!fim) {
        inicio = new Date(inicio);
        fim = new Date(fim);
        var diferenca = onTime
          ? new Date(fim - inicio)
          : new Date(inicio - fim);
        var resultado = diferenca.getUTCHours() + "h ";
        resultado += diferenca.getUTCMinutes() + "m ";
        resultado += diferenca.getUTCSeconds() + "s ";
      }
      return resultado;
    },
    getTitle() {
      var within24hours = this.within24hours();
      if (within24hours)
        return (
          "Seu pedido está chegando no limite, tá quase atrasado " +
          this.calculateHours(true)
        );
      var checkIfTheDeadlineHasPassed = this.checkIfTheDeadlineHasPassed();
      if (checkIfTheDeadlineHasPassed) return "Seu pedido está atrasado ";
      return "Pedido dentro do prazo " + this.calculateHours(true);
    },
    getStatus() {
      var within24hours = this.within24hours();
      if (within24hours) return within24hours;
      var checkIfTheDeadlineHasPassed = this.checkIfTheDeadlineHasPassed();
      if (checkIfTheDeadlineHasPassed) return checkIfTheDeadlineHasPassed;
      return this.checkSuccess();
    },
    getDataTimeOn() {
      var dataAtual = new Date();
      var dia = dataAtual.getDate();
      var mes = dataAtual.getMonth() + 1;
      var ano = dataAtual.getFullYear();
      var horas = dataAtual.getHours();
      var minutos = dataAtual.getMinutes();
      return ano + "-" + mes + "-" + dia + " " + horas + ":" + minutos;
    },
    within24hours() {
      var dataAtual = this.getDataTimeOn();
      var dataInicio = new Date(dataAtual);
      var dataFim = new Date(this.estimate_delivery_date);
      var diffMilissegundos = dataFim - dataInicio;
      var diffSegundos = diffMilissegundos / 1000;
      var diffMinutos = diffSegundos / 60;
      var diffHoras = diffMinutos / 60;
      var diffDias = diffHoras / 24;
      return diffDias > 0 && diffDias < 1 ? "warning" : null;
    },
    checkIfTheDeadlineHasPassed() {
      return this.parseDate(this.estimate_delivery_date) <
        this.parseDate(this.getDataTimeOn())
        ? "danger"
        : null;
    },
    checkSuccess() {
      return "success";
    },
    parseDate(dateString) {
      if (typeof dateString === "string") {
        dateString = dateString.replace("T", " ");
        dateString = dateString.replace(".000Z", "");
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const horas = date.getHours().toString().padStart(2, "0");
        const minutos = date.getMinutes().toString().padStart(2, "0");
        return `${year}-${month}-${day} ${horas}:${minutos}`;
      }
      return dateString;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Sla.vue